import "./ProjectCards.scss";
import { Col } from 'react-bootstrap'
import launch from "../../assets/images/launch.svg";
import code from "../../assets/images/code.svg";

const ProjectCards = ({title, description, imgUrl, link, ghLink}) => {
  return (
    <Col xs={12} md={6} xl={6} xxl={4}>
      <div className="project-card">
        <img src={imgUrl} alt="Project" />
        <div className="project-card__text">
          <h4 className="project-card__title">{title}</h4>
          <span className="project-card__description">{description}</span>
          <div className="project-card__links">
            {link && <a href={link} target="_blank" rel="noreferrer"><img src={launch} alt="launch icon" /></a>}
            <a href={ghLink} target="_blank" rel="noreferrer"> <img src={code} alt="code icon" /></a>
          </div>
        </div>
      </div>
    </Col>
  )
}

export default ProjectCards